import { NextPage } from "next";
import { useIntl } from "react-intl";
import { PageProps } from "@/pages/_app";
import Layout from "@/components/layout/Layout";
import { SEO } from "@/interfaces/seo";
import { SEOWithoutTemplate } from "@/interfaces/seoWithoutTemplate";
import HeroBlock, {
  HeroBlockProps,
} from "@/components/common/heroBlock/HeroBlock";
import { Section } from "@/components/common/section/Section";
import {
  DescriptiveBlockList,
  DescriptiveBlockListProps,
} from "@/components/common/descriptiveBlockList/DescriptiveBlockList";
import styles from "./Press.module.scss";

type ContactForm = {
  phone: string;
  email: string;
  name: string;
};

export type PressPageContent = {
  heroBlock: HeroBlockProps;
  contactForm: ContactForm;
  descriptiveBlockList: DescriptiveBlockListProps;
  seo: SEO;
  seoWithoutTemplate: SEOWithoutTemplate;
};

type PressPageProps = PageProps &
  PressPageContent & {
    defaultCanonicalRoute: string;
  };

export const Press: NextPage<PressPageProps> = ({
  layout,
  heroBlock,
  contactForm,
  descriptiveBlockList,
  seo,
  seoWithoutTemplate,
  defaultCanonicalRoute,
}: PressPageProps) => {
  const intl = useIntl();

  return (
    <Layout
      layout={layout}
      defaultCanonicalRoute={defaultCanonicalRoute}
      pageMeta={seo}
      title={seoWithoutTemplate.title}
      description={seoWithoutTemplate.description}
      breadcrumbs={[
        { title: intl.formatMessage({ id: "home" }), url: "/" },
        {
          title: intl.formatMessage({ id: `pressBreadcrumb` }),
          url: defaultCanonicalRoute,
        },
      ]}
    >
      <HeroBlock {...heroBlock} hideSearchBlock={true} />
      <Section>
        <div className={styles.contactForm}>
          <div className={styles.contact}>
            <div className={styles.label}>
              {intl.formatMessage({ id: "telephone" })}
            </div>
            <div className={styles.value}>{contactForm.phone}</div>
          </div>
          <div className={styles.contact}>
            <div className={styles.label}>
              {intl.formatMessage({ id: "email" })}
            </div>
            <div className={styles.value}>{contactForm.email}</div>
          </div>
          <div className={styles.contact}>
            <div className={styles.label}>
              {intl.formatMessage({ id: "pressName" })}
            </div>
            <div className={styles.value}>{contactForm.name}</div>
          </div>
        </div>
        <DescriptiveBlockList
          descriptiveBlocks={descriptiveBlockList.descriptiveBlocks}
        />
      </Section>
    </Layout>
  );
};
